import React from "react";

const ArrowRightTwo = () => {
  return (
    <svg
      width="26"
      height="9"
      viewBox="0 0 26 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6934 1L25 4.20003L21.6934 7.4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.999999 4.19897H25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowRightTwo;
